import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IGetProfessionalCountsParams } from '../types/IGetProfessionalCountsParams';
import { IProfessionalCountsResponse } from '../types/IProfessionalCountsResponse';

export const GetProfessionalCountsClient = {
  getProfessionalCountsByOffice: async ({
    officeId,
    distance,
    state,
  }: IGetProfessionalCountsParams): Promise<IProfessionalCountsResponse> => {
    const headers = await getAuthHeaders();

    const response = await tempMeeApi.get(
      `/offer-service/professionals/counts/offices/${officeId}`,
      {
        params: { distance, state },
        headers,
      },
    );

    return response.data;
  },
};
